module.exports = __webpack_public_path__ + "static/input-82836d2aa52f9c21834a32261dcec1df.png";